/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
==========================================================================================*/

import vm from '../../main.js'

import pouch from '@/db/pouch';

export default {
  addTruck({
    commit
  }, truck) {
    return new Promise(async (resolve, reject) => {
      try {
        return await pouch.en(truck).then(async (et) => {
          return await pouch.f({
            selector: {
              a: et.a,
              z: 2
            }
          }, true, false).then(async (sr) => {
            if (sr.hasOwnProperty('a')) {
              return reject('A truck exists with this number plate. Try again with a different number plate.');
            } else {
              return await pouch.c(et, true).then((ct) => {
                if (ct.ok) {
                  return resolve('Truck successfully registered');
                }
                return reject(ct.message);
              })
            }
          })
        });
      } catch (e) {
        return reject(e);
      }
    })
  },
  updateTruck({
    commit
  }, truck) {
    return new Promise(async (resolve, reject) => {
      return await pouch.f({
        selector: {
          _id: truck._id,
          z: 2,
        }
      }, true, false).then(async (sr) => {
        if (sr.hasOwnProperty('a')) {
          return await pouch.c(truck, false).then((ct) => {
            if (ct.ok) {
              return resolve('Truck successfully updated');
            }
            return reject(ct.message);
          }).catch((e) => reject(e))
        } else {
          return reject('This truck has not been found. It might no longer exist in your database.');
        }
      });
    })
  },
}